"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const styled_1 = require("./styled");
class ErrorBoundary extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
        this.reloadPage = () => {
            window.location.reload();
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true, error, errorInfo });
        console.error("Uncaught error:", error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return ((0, jsx_runtime_1.jsxs)(styled_1.StyledError, { children: [(0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", sx: { width: "100%", "& .MuiAlert-action": { pt: 0 } }, action: (0, jsx_runtime_1.jsx)(material_1.IconButton, { size: "small", onClick: this.reloadPage, children: (0, jsx_runtime_1.jsx)(icons_material_1.Refresh, {}) }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `alert.${process.env.NODE_ENV !== "production" ? "uncaughtError" : "knownError"}` }) }), process.env.NODE_ENV !== "production" ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { component: "pre", sx: { mb: 0 }, children: this.state.error?.toString() || "" }), (0, jsx_runtime_1.jsx)(material_1.Box, { component: "pre", sx: { mt: 0 }, children: this.state.errorInfo?.componentStack?.toString() || "" })] })) : null] }));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=index.js.map